import { setAppLoading, setAppStateMessage } from "./app";
import axios from '../../axios';
import { getVehicles } from "./vehicles";

export const OfferStatuses = { Active: 1, Applied: 2 };

export const applyOffer = (offerId, cb) => {
    return async (dispatch, getState) => {
        dispatch(setAppLoading(true));

        const onError = (err) => {
            dispatch(setAppLoading(false));
            dispatch(setAppStateMessage({type: 'error', msg: err }))
            cb && cb(err, null);
        };

        const token = getState().auth.token.id_token;
        try {
            const res = await axios.put(`offers`, { 
                'id': offerId,
                'status': OfferStatuses.Applied
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            });
            if (res.data && res.data.error) {
                throw new Error(res.data.error);
            }

            dispatch(getVehicles((error, vehicleRes) => {
                if (error) {
                    onError(error);
                    return ;
                }
                dispatch(setAppLoading(false));
                dispatch(setAppStateMessage({ type: 'success', msg: 'The offer has been applied' }));
                cb && cb(null, res);
            }));

        } catch(err) {
            console.log('err', err);
            onError(err.message);
        }
    }
};

export const isOfferApplied = (offer) => {
    return offer && (+offer.status) === OfferStatuses.Applied;
}

export const isOfferExpired = (offer) => {
    return !isOfferApplied(offer) && offer.expiresAt 
        && (new Date(offer.expiresAt)).getTime() < (new Date()).getTime()
}

export const filterActiveOffers = (offers) => {
    offers = Array.isArray(offers) && offers ? offers : [];
    return offers.filter(offer => {
        const canSellerApply = offer && offer['actions'] && offer['actions']['canSellerApply'];
        return canSellerApply;
    }, 0);
}